import { Container, Typography } from '@mui/material';

export default function MembershipPage() {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Typography variant="h4" fontWeight={700} align="center" gutterBottom>
        Membership
      </Typography>
      <Typography align="center" color="text.secondary">
        Welcome to the Membership page. More content coming soon!
      </Typography>
    </Container>
  );
} 